/**
 * Shared sidebar tree indent — campaigns, folders, and docs.
 * Depth 0 = 8px; each level adds 8px (Notion-style).
 */
export function sidebarTreeIndent(depth = 0) {
  return depth > 0 ? 8 + depth * 8 : 8;
}
